<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright2"><a id="page_v">This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously. Other names, characters, places, and incidents are the product of the author’s imagination, and any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.</a></p><a id="page_v">
<p class="imagez"><img alt="Image" src="images/copyright.jpg"/></p>
<p class="copyrightz">SIMON PULSE</p>
<p class="copyright1">An imprint of Simon &amp; Schuster Children’s Publishing Division</p>
</a><p class="copyright1"><a id="page_v">1230 Avenue of the Americas, New York, NY 10020<br/></a><a class="nounder" href="http://www.SimonandSchuster.com" target="_blank">www.SimonandSchuster.com</a></p>
<p class="copyright1">Copyright © 2007 by Nancy Holder</p>
<p class="copyright1">All rights reserved, including the right of<br/>reproduction in whole or in part in any form.</p>
<p class="copyright1">SIMON PULSE and colophon are registered trademarks<br/>of Simon &amp; Schuster, Inc.</p>
<p class="copyright1">The text of this book was set in Adobe Jenson.</p>
<p class="copyright1">Manufactured in the United States of America</p>
<p class="copyright1">First Simon Pulse edition June 2007</p>
<p class="copyright1">2 4 6 8 10 9 7 5 3</p>
<p class="copyright1">Library of Congress Control Number 2007923285</p>
<p class="copyright1">ISBN-13: 978-1-4169-3535-3</p>
<p class="copyright1">ISBN-10: 1-4169-3535-5</p>
<p class="copyright1">eISBN-13: 978-1-4424-3017-4</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2ec82e0a